import { SingleFaqQuestion } from "components/UI/molecules";
import "./index.scss";

export const FAQSection = ({ faqList }) => {
  return (
    <section className="section-faq-container" data-testid="section-faq">
      <h3 className="faq-section-title">Frequently Asked Questions</h3>
      <ul className="faq-questions">
        {faqList.map((item) => (
          <SingleFaqQuestion key={item.id} questionTitle={item.question}>
            {item.response}
          </SingleFaqQuestion>
        ))}
      </ul>
    </section>
  );
};
